
import { useState, useEffect } from 'react';
import { getSasUrl } from '../api/blobStorageService';

// Cache pour stocker uniquement les URLs valides déjà récupérées
const imageCache = new Map();

export const useBlobImage = (blobName, containerName = "domains") => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!blobName) {
      setImageUrl(null);
      setError(null);
      return;
    }

    // Réinitialiser l'état à chaque changement de blobName
    setImageUrl(null);
    setError(null);

    const cacheKey = `${containerName}/${blobName}`;

    // Vérifier le cache UNIQUEMENT si l'URL est valide (non nulle)
    if (imageCache.has(cacheKey)) {
      const cachedUrl = imageCache.get(cacheKey);
      if (cachedUrl) {
        setImageUrl(cachedUrl);
        return;
      } else {
        // Supprimer l'entrée invalide du cache pour réessayer
        imageCache.delete(cacheKey);
      }
    }

    const fetchImageUrl = async () => {
      setLoading(true);

      try {
        const url = await getSasUrl(blobName, containerName);

        if (url) {
          // Mettre en cache UNIQUEMENT les URLs valides, 25 minutes
          imageCache.set(cacheKey, url);
          setTimeout(() => imageCache.delete(cacheKey), 25 * 60 * 1000);
          setImageUrl(url);
        } else {
          // Ne PAS mettre en cache les échecs → permettre les nouvelles tentatives
          setError("Impossible de récupérer l'image");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchImageUrl();
  }, [blobName, containerName]);

  return { imageUrl, loading, error };
};